import React from 'react'

import Layout from '../components/layout'

const IndexPage = () => {
  const queryParams = new URLSearchParams(typeof window !== 'undefined' && window.location.search);
  let brand
  let mobile
  if(queryParams){
    brand = queryParams.get('brand');
    mobile = queryParams.get('mobile');
  }
  
  return(
    brand ?
    <Layout brand={brand} mobile={mobile} />
    :
    "Brand not found"
  )
}

export default IndexPage